import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image } from 'newComponents'
import './styles.scss'

const TextIconColumns = (props) => {
  const { data } = props
  const { primary } = data
  const { content, icon, align_image_left: imageLeft } = primary

  // content checks
  const contentHtml = content?.html
  const hasImage = icon?.url
  const imageAlign = imageLeft ? 'left-align' : ''

  return (
    <OnVisible className={`text-icon-columns ${imageAlign}`}>
      <Section className="text-icon-columns-container">
        {contentHtml && <div className="text-icon-columns-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
        {hasImage && <Image className="text-icon-columns-image" image={icon} />}
      </Section>
    </OnVisible>
  )
}

export default TextIconColumns
